import { __assign } from "tslib";
import { getResponsivePanelMargin } from '@cseo/coherence-utilities';
import { FontSizes, FontWeights, ScreenWidthMinMedium, ScreenWidthMinSmall } from '@fluentui/react';
export var getStyles = function (props) {
    var _a;
    var theme = props.theme, isFooterInBody = props.isFooterInBody, panelSize = props.panelSize;
    return {
        rootNotifications: {
            marginTop: '-12px'
        },
        rootNoNotifications: {
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.semibold,
            marginBottom: '4px',
            padding: '12px 32px 12px 32px'
        },
        undoView: {
            minWidth: '240px'
        },
        groupHeaderRow: {
            flexGrow: 1,
            justifyContent: 'space-between',
            margin: '12px 32px 4px 32px',
            selectors: (_a = {},
                _a["@media (min-width: " + ScreenWidthMinMedium + "px)"] = {
                    marginLeft: '32px',
                    marginRight: '32px'
                },
                _a["@media (min-width: " + ScreenWidthMinSmall + "px) and (max-width: " + (ScreenWidthMinMedium - 1) + "px)"] = {
                    marginLeft: '16px',
                    marginRight: '16px'
                },
                _a)
        },
        groupHeaderText: {
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.semibold,
            marginTop: '0px',
            marginBottom: '0px'
        },
        groupFooterRow: {
            flexGrow: 1,
            backgroundColor: theme.palette.neutralQuaternaryAlt,
            height: '1px',
            margin: '12px 32px 12px 32px'
        },
        dismissAllText: {
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.semibold,
            selectors: __assign({}, getResponsivePanelMargin(panelSize, !isFooterInBody))
        },
        footerAction: {
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.semibold,
            marginLeft: '20px'
        },
        messageBodyOnOpen: {
            margin: '15px 26px 15px 48px',
            border: '1px solid #D9D9D9',
            paddingLeft: 10,
            paddingRight: 4,
            wordBreak: 'break-word',
            overflowX: 'auto'
        },
        messageBodyContentOnOpen: {
            fontSize: FontSizes.size14,
            lineHeight: 20
        },
        subjectHeaderOnOpen: {
            fontSize: 20,
            marginLeft: 48,
            fontWeight: 600
        },
        headerBody: __assign(__assign({}, getResponsivePanelMargin(panelSize, undefined)), { marginTop: '1px' })
    };
};
//# sourceMappingURL=CoherenceNotificationPanel.styles.js.map